import { useEffect, useRef } from 'react';

/**
 * 유튜브 쇼츠를 9:16 오버레이로 띄운다.
 * 페이지 로드 시점에는 iframe 을 만들지 않고, 재생 버튼을 눌렀을 때만 붙인다.
 * (유튜브 임베드는 스크립트가 무거워서 3개를 미리 걸면 첫 로딩이 느려진다)
 */
export default function ShortsModal({ videoId, title, onClose }) {
  const closeRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    if (closeRef.current) closeRef.current.focus();

    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);

  const src =
    `https://www.youtube-nocookie.com/embed/${videoId}` +
    '?autoplay=1&rel=0&modestbranding=1&playsinline=1';

  return (
    <div
      className="lw-modal"
      role="dialog"
      aria-modal="true"
      aria-label={`${title} 쇼츠`}
      onClick={onClose}
    >
      {/* 패널은 overflow:hidden 이라 닫기 버튼을 안에 두면 잘린다. 오버레이 직속으로 둔다 */}
      <button
        className="lw-modal__close"
        ref={closeRef}
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        aria-label="닫기"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
          <path
            d="M3 3 L13 13 M13 3 L3 13"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      </button>

      <div className="lw-modal__panel" onClick={(e) => e.stopPropagation()}>
        <iframe
          className="lw-modal__video"
          src={src}
          title={`${title} 쇼츠`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
    </div>
  );
}
